module.exports = __webpack_public_path__ + "img/icon3.5c97c748.png";